import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MainMenu from './MainMenu';
import Email from '@material-ui/icons/Email';
import Constants from './Constants.js';
import Tooltip from '@material-ui/core/Tooltip';
import {useLocation, useHistory} from "react-router-dom";
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
	marginBottom: '3.5rem'
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  headerBar: {
	backgroundColor: 'teal'
  },
  toolbar: {
	display: 'grid',
	gridTemplateColumns: '1fr 1fr 1fr'
  },
  leftToolbar: {
	  display: 'flex',
	  alignItems: 'center'
  },
  rightToolbar: {
	  display: 'flex',
	  justifyContent: 'flex-end'
  },
  textFields: {
	  minWidth: '300px',
	  maxWidth: '300px',
	  paddingBottom: '0.5rem',
	  paddingRight: '0.5rem'
  },
  multilineText: {
	  minWidth: '300px',
	  paddingBottom: '0.5rem',
  },
  drawer: {
	  display: 'grid',
	  margin: '1rem' 
  },
   buttons: {
	  minWidth: '300px',
	  maxWidth: '300px',
	  paddingBottom: '0.5rem',
	  marginRight: '0.5rem'
  },
  icon: {
	  color: 'white'
  }
}));

export default function HeaderBar(props) {
	const {isNotMobile} = props;
	const classes = useStyles();
	const {pageMessages} = Constants;
	let location = useLocation();
	let history = useHistory();
	/*const [anchor, setAnchor] = useState(false);
	const [name, setName] = useState('');
	const [email, setEmail] = useState('');
	const [message, setMessage] = useState('');
	const [valid, setValid] = useState(false);*/
	
	/*const clearForm = () => {
		setName('');
		setEmail('');
		setMessage('');
	};*/
	
	const navigateHome = () => {
		history.push('/');
	};
	
	/*const handleChange = (value, field) => {
		if (field === 'email') {
			setEmail(value);
		}
		if (field === 'name') {
			setName(value);
		}
		if (field === 'message') {
			setMessage(value);
		}
		if (email.length && message.length && name.length) {
			setValid(true);
		}
		else {setValid(false);}
	};
	
	const sendMessage = () => {
		
	}*/
	
	return (
		<div className={classes.root}>
			<AppBar position="fixed" className={classes.headerBar}>
			<Toolbar className={classes.toolbar}>
			<div className={classes.leftToolbar}>
				<MainMenu/>
				{isNotMobile && 
					<Typography>
						{location?.pathname && pageMessages[location.pathname?.replace('/', '')]}
					</Typography>
				}
			</div>
			<Button onClick={navigateHome} size="large" color="inherit">Imagination Acres Farm</Button>
			<div className={classes.rightToolbar}>
				<Tooltip title={'Contact the farm'}>
					<IconButton
						aria-label="Contact the Farm"
						color="inherit"	
						//onClick={() => setAnchor(!anchor)}
					>
						<a href="mailto:imaginationacres@gmail.com">
							<Email className={classes.icon}/>
						</a>
					</IconButton>
				</Tooltip>
			</div>
			</Toolbar>
			</AppBar>
		</div>
	);
};
